import PropTypes from "prop-types";
import * as React from "react";
import { Chip, SectionHead, Typography } from "../../../themeV2";
import SignerPicker from "./SignerPicker";
import SignTypeCard from "./SignTypeCard";
import css from "./SignTypeCard.module.css";
import sectionCss from "./sections.module.css";

const SignerList = function SignerList({ state, dispatch, readOnly }) {
  return (
    <div className={sectionCss.fields}>
      <Typography variant="title-sm" as="h4">
        Signers
      </Typography>
      <div className={sectionCss.chips}>
        {state.signers.map((signer) => (
          <Chip
            key={signer.influencerId}
            variant="input"
            size="sm"
            label={signer.name}
            avatar={signer.avatarUrl ?? undefined}
            onDelete={
              readOnly || state.signers.length === 1
                ? undefined
                : () =>
                    dispatch({
                      type: "removeSigner",
                      influencerId: signer.influencerId,
                    })
            }
          />
        ))}
      </div>
      {!readOnly && (
        <div className={sectionCss.signerPicker}>
          <SignerPicker
            excludedIds={state.signers.map((s) => s.influencerId)}
            onAdd={(signer) => dispatch({ type: "addSigner", signer })}
          />
        </div>
      )}
    </div>
  );
};

SignerList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  state: PropTypes.object.isRequired,
};

const SignTypePricing = function SignTypePricing({
  state,
  dispatch,
  signedTypes,
  canToggle,
  bumpFacts,
  visibleSignerIds,
  canManageSigners,
  readOnly,
}) {
  return (
    <section className={sectionCss.section}>
      <SectionHead
        title={canToggle ? "Sign types and pricing" : "Pricing"}
        as="h3"
      />
      {canToggle && (
        <Typography variant="body-md" color="variant" as="p">
          Turn on each way you&apos;ll sign it and set your price. Each becomes
          its own listing on your shop.
        </Typography>
      )}

      {canManageSigners && (
        <SignerList state={state} dispatch={dispatch} readOnly={readOnly} />
      )}

      <ul className={css.list}>
        {signedTypes.map((signedType) => (
          <SignTypeCard
            key={signedType}
            signedType={signedType}
            isOn={state.signedTypes.includes(signedType)}
            canToggle={canToggle}
            signers={state.signers}
            visibleSignerIds={visibleSignerIds}
            stock={state.stock[signedType]}
            bumpFacts={bumpFacts}
            readOnly={readOnly}
            dispatch={dispatch}
          />
        ))}
      </ul>
    </section>
  );
};

SignTypePricing.propTypes = {
  bumpFacts: PropTypes.object.isRequired,
  canManageSigners: PropTypes.bool,
  canToggle: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  signedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  state: PropTypes.object.isRequired,
  visibleSignerIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default SignTypePricing;
